import React from 'react'
import styles from './index.less'

interface ParmsProps {
    text1: string
    focusText: string
    text2?: string
    num?: string | number
}

export default React.memo(({ text1, focusText, text2, num }: ParmsProps) => {
    return (
        <span>
            {text1}
            <span className={styles.red}>{focusText}</span>
            {text2}
        </span>
    )
})
